export default __webpack_public_path__ + "static/media/message.838a78b6.svg";